import { render, staticRenderFns } from "./ConversationSummary.vue?vue&type=template&id=fded7c38&scoped=true&"
import script from "./ConversationSummary.vue?vue&type=script&lang=js&"
export * from "./ConversationSummary.vue?vue&type=script&lang=js&"
import style0 from "./ConversationSummary.vue?vue&type=style&index=0&id=fded7c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fded7c38",
  null
  
)

export default component.exports